export class Perfil {
  id: number;
  nome: string;
  descricao: string;
  ativo: boolean;
  permissoes: string[];

  constructor(
    id: number,
    nome: string,
    descricao: string,
    ativo: boolean,
    permissoes: string[],
  ) {
    this.id = id;
    this.nome = nome;
    this.descricao = descricao;
    this.ativo = ativo;
    this.permissoes = permissoes;
  }
}
